<template>
  <div
    class="is-border vadTask"
    :class="{'is-grey has-text-grey': !isPending, 'has-background-white': isPending}">
    <div class="vadTask-hover"></div>
    <div class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
      <div class="columns">
        <div class="column is-narrow">
          <avatar
            :use-picto-custom="'fas fa-bullhorn'"
            :force-picto="true"
            :is-avatar="false"
            :item="{}"
            class="has-background-optioned is-medium has-text-white is-margin-top-xsmall">
          </avatar>
        </div>
        <div class="column">
          <p class="is-size-7 has-text-weight-light has-text-grey is-margin-bottom-xxsmall">
            <span v-if="isToday">Aujourd’hui à {{ claim.created_on | prettyTime }}</span>
            <span v-else>{{ claim.created_on | prettyDatetime }}</span>
          </p>
          <p class="is-size-4">
            <strong>Dénonciation —
              <router-link :to="{name: 'ProgramVue', params: {id: claim.program.pk}}">{{ claim.program.name }}</router-link>
            </strong>
          </p>
          <div class="columns is-multiline">
            <div class="column is-narrow">
              <span class="has-text-grey is-size-6">Vendeur :</span><br>
              <router-link
                :to="{name: 'UserVue', params: {id: claim.user.pk}}"
                class="is-size-6">
                <span class="is-hover-underline">{{ claim.user.first_name }} {{ claim.user.last_name }}</span>
              </router-link>
            </div>
            <div
              v-if="claim.user.account.pk !== currentUser.account.pk"
              class="column is-narrow">
              <span class="has-text-grey is-size-6">Société :</span><br>
              <router-link
                :to="{name: 'CompanyVue', params: {id: claim.user.account.pk}}"
                class="is-size-6">
                <span class="is-hover-underline">{{ claim.user.account.name }}</span>
              </router-link>
            </div>
            <div class="column is-narrow">
              <span class="has-text-grey is-size-6">Contact :</span><br>
              <router-link
                v-if="'contact' in claim && claim.contact.account.pk === currentUser.account.pk"
                :to="{name: 'ContactVue', params: {id: claim.contact.pk}}"
                class="is-size-6">
                <span class="is-hover-underline">{{ claim.contact.first_name }} {{ claim.contact.last_name }}</span>
              </router-link>
              <span
                v-else-if="'contact' in claim"
                class="is-size-6">{{ claim.contact.first_name }} {{ claim.contact.last_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="(claim && claim.duplicates && claim.duplicates.length > 0 ) || (claim && claim.all_pk_contact && claim.all_pk_contact.length > 0)"
      class="has-background-danger">
      <div class="has-text-white margin-left  is-size-7 is-padding-top-xsmall is-padding-bottom-xsmall">
        <i>DONNÉES SIMILAIRES DÉTECTÉES SUR : </i>
        <router-link :to="{ name: 'DenunciationList', params: { filter: claim_list_pk, status: ['approved', 'pending'], resetFiltersForDoublon: true }}">
          <a
            v-if="claim.duplicate_risk"
            class="is-size-7 has-text-white is-padding-right-xsmall">
            <span> BASE DÉNONCIATION </span>
            <a class="hover-text">
              <span class="is-size-7 has-text-white">(<a class="is-size-7 has-text-white">{{ claim.duplicate_risk || 0 }}/3 </a><i class="fas fa-info-circle"></i>)</span>
              <span
                class="tooltip-text"
                id="top">{{ messages[claim.duplicate_risk - 1] }}</span>
            </a>
          </a>
        </router-link>
        <router-link :to="{ name: 'ContactList', params: { filter: claim.all_pk_contact, resetFiltersForDoublon: true}}">
          <a
            v-if="claim.all_pk_contact"
            class="is-size-7 has-text-white">
            <span> BASE CONTACT </span>
            <a class="hover-text">
              <span class="is-size-7 has-text-white">(<a class="is-size-7 has-text-white">{{ claim.all_pk_contact_risk || 0 }}/3 </a><i class="fas fa-info-circle"></i>)</span>
              <span
                class="tooltip-text"
                id="top">{{ messages_2[claim.all_pk_contact_risk - 1] }}</span>
            </a>
          </a>
        </router-link>
      </div>
    </div>
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      mode="out-in">
      <div
        v-if="isPending"
        key="buttons"
        class="veryFastAnimation is-paddingless-top is-paddingless-bottom is-border-top is-border--dashed vadTask-footer columns is-gapless">
        <div class="column is-narrow-widescreen">
          <button
            @click="approve"
            class="button is-white is-small is-size-7 is-fullwidth"
            :disabled="cardLoading">
            <span class="icon is-small"><i class="fas fa-check"></i></span>
            <span>Accepter</span>
          </button>
        </div>
        <div class="column is-narrow-widescreen">
          <button
            @click="refuse"
            class="button is-white is-small is-size-7 is-fullwidth"
            :disabled="cardLoading">
            <span class="icon is-small"><i class="fas fa-do-not-enter"></i></span>
            <span>Décliner</span>
          </button>
        </div>
        <div class="column is-narrow-widescreen">
          <button
            @click="checkDuplicate"
            v-if="isPromoteur"
            class="button is-white is-small is-size-7 is-fullwidth"
            :disabled="cardLoading">
            <span class="icon is-small"><i class="fas fa-id-card-alt"></i></span>
            <span>Vérifier</span>
          </button>
        </div>
      </div>
      <div
        v-else-if="!isPending && lastEvent"
        key="noButtons"
        class="veryFastAnimation is-padding-top-xsmall is-padding-bottom-xsmall is-border-top vadTask-footer has-background-light--darken1 is-border-top is-border--dashed ">
        <div class="">
          <span class="has-text-grey is-size-6">{{ lastEvent.created_on.seconds | dtUnixFormat('DD/MM HH:mm') }} : {{ lastEvent.title }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { firestore as db } from '../../firebaseApp'
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ClaimCard',
  props: {
    claim: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      cardLoading: false,
      logs: [],
      colors: ['is-optioned', 'is-warning', 'is-danger'],
      messages: ['Doublon Nom/Prénom', 'Doublon Nom/Prénom et Adresse', 'Doublon Email'],
      messages_2: ['Doublon Nom/Prénom', 'Doublon Nom/Prénom et Adresse', 'Doublon Email'],
      claim_list_pk: []
    }
  },
  computed: {
    ...mapGetters(['currentUserPk', 'isAdmin', 'isPromoteur']),
    ...mapState(['currentUser']),
    /**
      * date of the claim creation
      * @return {date}
      */
    date () {
      return moment(this.claim.created_on)
    },
    /**
      * is today
      * @return {boolean}
      */
    isToday () {
      return this.date.isSame(moment(), 'day')
    },
    /**
      * claim pk
      * @return {string}
      */
    claimPk () {
      return this.claim.pk
    },
    /**
      * claim status
      * @return {string}
      */
    status () {
      return this.claim.status
    },
    /**
      * status is approved
      * @return {boolean}
      */
    isApproved () {
      return this.status === 'approved'
    },
    /**
      * status is refused
      * @return {boolean}
      */
    isRefused () {
      return this.status === 'refused'
    },
    /**
      * status is pending
      * @return {boolean}
      */
    isPending () {
      return this.status === 'pending'
    },
    /**
      * last event from logs
      * @return {object}
      */
    lastEvent () {
      if (this.logs.length > 0) {
        return this.logs[0]
      }
      return null
    }
  },
  async created () {
    this.$bind('logs', db.collection('claim').doc(this.claim.pk).collection('events').orderBy('created_on', 'desc'))
    await this.getDoublons()
    await this.getClaimContact()
  },
  methods: {
    async getClaimContact () {
      if (this.claim && this.claim.duplicates.length > 0) {
        this.claim_list_pk = []
        for (let i of this.claim.duplicates) {
          let params = null
          if (i.pk) {
            params = {
              status: ['approved', 'pending'],
              contact: i.pk
            }
          } else {
            params = {
              status: ['approved', 'pending'],
              contact: i
            }
          }
          let { data } = await this.$api.get(this.$resources.CLAIM, params)
          data.items.forEach(claim => { this.claim_list_pk.push(claim.pk) })
        }
        this.claim_list_pk.push(this.claim.pk)
      }
    },
    async getDoublons () {
      try {
        const { data } = await this.$api.get(this.$resources.CLAIM_CHECK(this.claimPk))
        if (data.duplicates.length !== 0 || data.all_pk_contact.length !== 0) {
          this.claim.duplicates = data.duplicates
          this.claim.duplicate_risk = data.duplicate_risk
          this.claim.all_pk_contact_risk = data.all_pk_contact_risk
          this.claim.all_pk_contact = data.all_pk_contact
          this.claim.all_pk_contact.push(this.claim.contact.pk)
        }
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * emit update claim with status approved
      */
    async approve () {
      this.$emit('updateClaim', this.claim.pk, 'approved')
    },
    /**
      * emit update claim with status refused
      */
    async refuse () {
      this.$emit('updateClaim', this.claim.pk, 'refused')
    },
    async checkDuplicate () {
      this.cardLoading = true
      try {
        const { data } = await this.$api.get(this.$resources.CLAIM_CHECK(this.claimPk))
        this.cardLoading = false
        if (data.duplicates.length > 0 || data.all_pk_contact.length > 0) {
          this.claim.duplicates = data.duplicates
          this.claim.duplicate_risk = data.duplicate_risk
          this.claim.all_pk_contact = data.all_pk_contact
          this.claim.all_pk_contact_risk = data.all_pk_contact_risk
          if (this.claim.all_pk_contact.length > 0) {
            this.claim.all_pk_contact.push(this.claim.contact.pk)
          }
          this.$toasted.global.danger('Doublon trouvé')
          this.getClaimContact()
          this.getDoublons()
        } else {
          this.claim.duplicates = null
          this.claim.duplicate_risk = null
          this.claim.all_pk_contact = null
          this.claim.all_pk_contact_risk = null
          this.$toasted.global.success('Aucun doublon trouvé')
        }
      } catch (e) {
        this.cardLoading = false
        console.log(e)
      }
    },
    showDuplicates (claim) {
      if (claim.duplicate_risk === 1) {
        this.$router.push({ name: 'DenunciationList', query: { contact__searchable_name: `${claim.contact.first_name} ${claim.contact.last_name}`, status: ['approved', 'pending'] } })
      }
      if (claim.duplicate_risk === 2) {
        this.$router.push({ name: 'DenunciationList', query: { contact__email: claim.contact.email, status: ['approved', 'pending'] } })
      }
      if (claim.duplicate_risk === 3) {
        this.$router.push({ name: 'DenunciationList', query: { contact__email: claim.contact.email, status: ['approved', 'pending'] } })
      }
    }
  }
}
</script>
<style>
.margin-left {
  margin-left: 7.5rem;
}

.tooltip-text {
  visibility: hidden;
  position: absolute;
  z-index: 1;
  width: 100px;
  color: white;
  font-size: 12px;
  background-color:  #474849;
  border-radius: 10px;
  opacity: 0.80;
  padding: 5px 10px 5px 10px;
}

.hover-text:hover .tooltip-text {
  visibility: visible;
}

#top {
  top: -8px;
  left: 105%;
}

.hover-text {
  position: relative;
  display: inline-block;
  font-family: Roboto;
}

</style>
